import CardWithArrowLink from 'components/shared/CardWithArrowLink'
import CustomerCardContent from 'components/shared/CardWithArrowLink/CustomerCardContent'
import classnames from 'classnames/bind'
import css from './styles.module.scss'

const cx = classnames.bind(css)

const ReviewCard = ({ className, item, isNameBlue, isSimpleCard }) => {
  return (
    <CardWithArrowLink
      arrowLayout="spread"
      className={cx(className, css.isSimpleCard)}
      link={item.link}
      withBorder
    >
      <CustomerCardContent
        logo={item.logo}
        text={item.quote}
        author={item.author}
        isNameBlue={isNameBlue}
        isSimpleCard={isSimpleCard}
      />
    </CardWithArrowLink>
  )
}

export default ReviewCard
